import {actionMap} from '../reducers/index'
import * as types from './types'

export default () => dispatch => {
    dispatch({type: types.RESET_FLIGHT_WEATHER})
}

export const handler_RESET_FLIGHT_WEATHER = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: undefined
    })
}

actionMap[types.RESET_FLIGHT_WEATHER] = handler_RESET_FLIGHT_WEATHER



// WEBPACK FOOTER //
// ./src/screens/briefing/weather/actions/resetFlightWeather.js